import { BiError } from "react-icons/bi";
import { Skeleton } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Reports, { ChecklistReportType } from "../service/Reports";
import './stylesImg.css';
import { trackEventMatomo } from "../helpers/matomo";
import { useTranslation } from "react-i18next";
import QueryFn from "../helpers/QueryFn";

const reportsService = new Reports();
const queryFn = new QueryFn();

const ImagesCmpAssinatura = ({ images, selected }: { images: string[], selected: ChecklistReportType }) => {
  const { t } = useTranslation('translation');
  const [image, setImage] = useState<string>('');
  const { mutate, data, isPending } = queryFn.useMutate('GET_IMAGES',
    async (path: string) => {
      const response = await reportsService.getImages([path]);
      return response;
    }
  );

  function resizeBase64Image(base64Image: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64Image;
      img.onload = () => {
        let newWidth = 130;
        let newHeight = 230;

        const canvas = document.createElement('canvas');
        canvas.width = newHeight;
        canvas.height = newWidth;

        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.translate(0, 130);
          ctx.rotate(-Math.PI / 2);

          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          const resizedBase64 = canvas.toDataURL('image/jpeg');
          resolve(resizedBase64);
          setImage(resizedBase64);
        } else {
          reject(new Error("Erro ao obter contexto 2D"));
        }
      };
      img.onerror = (err) => {
        console.error("Erro ao carregar a imagem: ", err);
        resolve('/sem_anexo.png');
      };
    });
  }

  useEffect(() => {
    mutate(images[0]);
  }, []);

  useEffect(() => {
    resizeBase64Image(data);
  }, [isPending]);

  return (isPending)
    ? (<Skeleton variant="rounded" width={230} height={130}/>)
    : (<>
      {data ?
        <img style={{ objectFit: 'cover' }} src={image} alt="Imagem" />
        : (
          <div className="div2">
            <div className="div3">
              <div className='imgNotFound'>
                <BiError size={18} />
                <span style={{ fontSize: '10px', textAlign: 'center' }}>{`${t('users.imageNotFound')}`}</span>
              </div>
            </div>
          </div>
        )
      }
    </>);
};

export default ImagesCmpAssinatura;